enum IconEnum {
  '01d' = 'clear-day',
  '02d' = 'partly-cloudy-day',
  '03d' = 'cloudy',
  '04d' = 'cloudy',
  '09d' = 'rain',
  '10d' = 'showers-day',
  '11d' = 'thunder',
  '13d' = 'snow',
  '50d' = 'fog',
  '01n' = 'clear-night',
  '02n' = 'partly-cloudy-night',
  '03n' = 'cloudy',
  '04n' = 'cloudy',
  '09n' = 'rain',
  '10n' = 'showers-night',
  '11n' = 'thunder',
  '13n' = 'snow',
  '50n' = 'fog',
}

export default IconEnum
